import { I18n } from "@/i18n";
import { css } from "@styled-system/css";
import { Flex } from "@styled-system/jsx";
import { getActivePromotionData } from "@/modules/promotions/getPromotionData";
import AppImage from "@/components/react/AppImage";
import SaveBadge from "./SaveBadge";

type Props = { className?: string };

function getGiftCardImg(theme: Strapi.Promotion["GiftcardTheme"]) {
  const locale = I18n.locale.toUpperCase();
  if (theme === "Christmas") return `giftCardChristmas${locale}.jpg`;
  if (theme === "Valentine") return `giftCardValentine${locale}.jpg`;
  if (theme === "Spring") return `giftCardSpring${locale}.jpg`;
  if (theme === "Summer") return `giftCardSummer${locale}.jpg`;
  if (theme === "Autumn") return `CardAutumn${locale}.jpg`;
  return `giftCard${locale}.jpg`;
}

export function GiftCardHeader({ className }: Props) {
  const { giftcardDiscount, giftcardTheme } = getActivePromotionData() || {};

  return (
    <Flex position="relative" justifyContent="center" className={className}>
      {giftcardDiscount && <SaveBadge save={giftcardDiscount} />}
      <AppImage
        alt="giftCard"
        ignoreTheme
        src={getGiftCardImg(giftcardTheme)}
        className={css({ borderRadius: "1rem" })}
      />
    </Flex>
  );
}
